import React, { createContext, useState, useContext, useEffect } from 'react';
import languages from './language.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || window.location.hostname === 'chat.acceptancegroup.org' ? 'ru' : 'en');

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const currentLanguageData = languages[language];

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, languages, currentLanguageData }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
